// @flow
import React, { type ElementRef } from "react";
import NativeSelect from "components/NativeSelect";
import {
    type SearchValueTypeEnum,
    SearchValueType,
    SearchOperator,
    type SearchOperatorEnum,
} from "data/types";
import styles from "./SearchOperators.module.css";
import loc from "i18next";

/** map which SearchOperators are available for which Search SearchValueType */
export const SearchValueTypeOperatorsMapping = {
    [SearchValueType.NotSet]: ["Equals"], // special $FREETEXT$ field
    [SearchValueType.ItemType]: ["Equals"],
    [SearchValueType.FileSize]: ["Equals"],
    [SearchValueType.String]: [
        "Contextor",
        "ContextorContains",
        "Contains",
        "Equals",
        "StartsWith",
        "EndsWith",
    ],
    [SearchValueType.Link]: [],
    [SearchValueType.StringFieldOnly]: [
        "Contextor",
        "ContextorContains",
        "Contains",
        "Equals",
        "StartsWith",
        "EndsWith",
    ],
    [SearchValueType.RelativeDate]: [
        "Contextor",
        "From",
        "FromWithTime",
        "To",
        "ToWithTime",
        // TODO "FromTo",
        // TODO "FromToWithTime",
        "Equals",
        "EqualsWithTime",
        "RelativeDate",
        // #46483 remove not working date searchform Operators
        // "FromRelativeTo",
        // "FromRelativeToWithTime",
        // "FromToRelative",
        // "FromWithTimeToRelative",
        "FromRelative",
        "ToRelative",
    ],
    [SearchValueType.DateTime]: [
        "Contextor",
        "From",
        "FromWithTime",
        "To",
        "ToWithTime",
        "FromTo",
        "FromToWithTime",
        "Equals",
        "EqualsWithTime",
        "RelativeDate",
        // #46483 remove not working date searchform Operators
        // "FromRelativeTo",
        // "FromRelativeToWithTime",
        // "FromToRelative",
        // "FromWithTimeToRelative",
        "FromRelative",
        "ToRelative",
    ],
    [SearchValueType.Decimal]: ["Contextor", "From", "To", "FromTo", "Equals"],
    [SearchValueType.DecimalFieldOnly]: [
        "Contextor",
        "From",
        "To",
        "FromTo",
        "Equals",
    ],
    [SearchValueType.GeoPoint]: ["GeoRadius", "GeoArea"],
    [SearchValueType.GeoArea]: [
        "GeoRadiusIntersect",
        "GeoRadiusWithin",
        "GeoAreaIntersect",
        "GeoAreaWithin",
        "GeoAreaPoint",
    ],
};

/** get localized searchOperators */
const getOperatorsForField = (valueType: SearchValueTypeEnum) =>
    SearchValueTypeOperatorsMapping[valueType].map((K) => ({
        // special handling for those that have only Contextor (and no Contextor.StartsWith/Contains)
        T:
            K === "Contextor" &&
            (valueType === SearchValueType.DateTime ||
                valueType === SearchValueType.Decimal ||
                valueType === SearchValueType.DecimalFieldOnly)
                ? loc.t("search:form.op.Choose")
                : loc.t("search:form.op." + K),
        K: SearchOperator[K],
    }));

type Props = {
    /** React.createRef to assign to NativeSelect element */
    selectRef?: ElementRef<*>,
    /** search field type */
    valueType: SearchValueTypeEnum,
    /** current seach operator */
    value: SearchOperatorEnum,
    /** callback when user changes the search operator
     * @param {SearchOperatorEnum} op new searchOperator key chosen
     */
    onChange: (op: SearchOperatorEnum) => void,
};

/** render SearchOperators dropdown */
export default class SearchOperators extends React.PureComponent<Props> {
    render() {
        const { selectRef, valueType, value, onChange } = this.props;
        const operators = getOperatorsForField(valueType);
        if (valueType === SearchValueType.NotSet)
            return <div className={styles.empty} />;
        else
            return (
                <NativeSelect
                    selectRef={selectRef}
                    options={operators}
                    valueKey={"K"}
                    labelKey="T"
                    wrapperClassName={styles.select}
                    value={operators.find((o) => o.K === value) || operators[0]}
                    onChange={(o) => onChange(o.K)}
                />
            );
    }
}
